"use client";

import dynamic from 'next/dynamic';

import { Hero } from '@/components/Hero';
import { ServicesGrid } from '@/components/ServicesGrid';
import { ServiceAreas } from '@/components/ServiceAreas';

// Dynamically import components that are not critical for the initial load
const ReviewsWidget = dynamic(() => import('@/components/ReviewsWidget').then((mod) => mod.ReviewsWidget));
const ServiceAreaMap = dynamic(() => import('@/components/ServiceAreaMap').then((mod) => mod.ServiceAreaMap));
const Testimonials = dynamic(() => import('@/components/Testimonials').then((mod) => mod.Testimonials));
const FAQAccordion = dynamic(() => import('@/components/FAQAccordion').then((mod) => mod.FAQAccordion));
const CallToAction = dynamic(() => import('@/components/CallToAction').then((mod) => mod.CallToAction));
const NewsletterSignup = dynamic(() => import('@/components/NewsletterSignup').then((mod) => mod.NewsletterSignup));




export default function HomePage() {
  const faqs = [
    {
      question: 'Do you offer drywall repair for water damage?',
      answer: 'Yes—assessment, proper drying, replacement where necessary, and finishing to match existing surfaces.',
    },
    {
      question: 'Can you match existing textures?',
      answer: 'Absolutely. We match knockdown, orange peel, smooth, and custom finishes for seamless repairs.',
    },
    {
      question: 'Which areas do you serve?',
      answer: 'Casper, Evansville, Mills, and surrounding communities throughout Natrona County and all surrounding regions.',
    },
    {
      question: 'Are quotes free?',
      answer: 'Yes—contact us to schedule a free, no-obligation quote.',
    },
  ];

  return (
    <>
      <Hero
        title="Expert Plastering, Stucco & Drywall Repair in Casper, WY"
        description="Local, reliable, and detail-driven. From stucco and plaster to drywall repair and installation—we handle it all."
        imageSrc="/images/3.png"
        imageAlt="Plastering team applying stucco finish on an exterior wall"
        ctaLabel="Get Free Quote"
        ctaHref="/contact"
        priority
        overlay="dark"
        textTone="light"
        textOutline="none"
      />
      <ServicesGrid />
      <ServiceAreas />
      <ReviewsWidget />
      <ServiceAreaMap />
      <Testimonials />
      <FAQAccordion faqs={faqs} />
      <NewsletterSignup />
      <CallToAction />
    </>
  );
}
